import { useMutation } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { api } from "../../api/client";
import { useDialogs } from "../../components/Dialogs";
import { useCurrentUser } from "../../lib/auth";
import { AssistantAccess } from "./AssistantAccess";

export function AccountSettings() {
  const me = useCurrentUser();
  const { toast } = useDialogs();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirmNext, setConfirmNext] = useState("");
  const change = useMutation({
    meta: { inlineError: true },
    mutationFn: () => api.changePassword(current, next),
    onSuccess: () => {
      setCurrent("");
      setNext("");
      setConfirmNext("");
      toast("Password changed", "info");
    },
  });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    change.mutate();
  };
  return (
    <div className="form-stack settings-form">
      <div className="props">
        <div className="prop-row">
          <div className="prop-label">Username</div>
          <div className="prop-value">{me.username}</div>
        </div>
        <div className="prop-row">
          <div className="prop-label">Name</div>
          <div className="prop-value">{me.display_name}</div>
        </div>
        <div className="prop-row">
          <div className="prop-label">Role</div>
          <div className="prop-value">{me.role}</div>
        </div>
      </div>
      <form className="form-stack" onSubmit={submit}>
        <h3 className="section-label">Change password</h3>
        <label className="field">
          <span className="field-label">Current password</span>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
        </label>
        <label className="field">
          <span className="field-label">New password</span>
          <input
            className="input"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
          />
        </label>
        <label className="field">
          <span className="field-label">Confirm new password</span>
          <input
            className="input"
            type="password"
            autoComplete="new-password"
            value={confirmNext}
            onChange={(e) => setConfirmNext(e.target.value)}
          />
        </label>
        {next && confirmNext && next !== confirmNext && <span className="error-text small">Passwords do not match</span>}
        {change.error && <div className="error-box">{change.error.message}</div>}
        <div className="row-actions row-actions-start">
          <button className="btn btn-primary" disabled={!next || next !== confirmNext || change.isPending}>
            Change password
          </button>
        </div>
      </form>
      <AssistantAccess />
    </div>
  );
}
